import React from "react";
import { Link } from "react-router-dom";
import { Briefcase, ShoppingBag, ArrowRight, ShieldCheck, HeartHandshake } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";
import { useRegisterModal } from "@/components/RegisterModal";

const Paywall = () => {
  const { t } = useI18n();
  const { open: openRegister } = useRegisterModal();
  return (
    <section className="min-h-[80vh] bg-cream py-16">
      <div className="container-tight max-w-6xl">
        <div className="text-center">
          <p className="eyebrow text-orange">{t.nav.directory}</p>
          <h1 className="font-display text-4xl md:text-5xl text-teal-deep leading-tight mt-3" data-testid="paywall-title">
            {t.paywall.title}
          </h1>
          <p className="text-teal-soft text-base mt-3">{t.paywall.subtitle}</p>
        </div>

        <div className="mt-12 max-w-2xl mx-auto text-center">
          <p className="font-display text-2xl md:text-3xl text-teal-deep leading-snug italic">
            {t.paywall.invite}{" "}
            <span className="text-orange not-italic">{t.paywall.inviteCta}</span>
          </p>
        </div>

        <div className="mt-10 flex justify-center">
          <button
            type="button"
            onClick={openRegister}
            className="btn-orange text-lg px-8 py-4 shadow-xl shadow-orange/30 hover:shadow-2xl transition-all"
            data-testid="paywall-cta"
          >
            <HeartHandshake size={18} /> {t.paywall.registerCta} <ArrowRight size={16} />
          </button>
        </div>

        <p className="text-center text-sm text-teal-soft mt-8">
          {t.paywall.already}{" "}
          <Link to="/login" className="text-orange font-bold hover:underline">
            {t.paywall.loginLink}
          </Link>
        </p>

        <div className="mt-12 max-w-2xl mx-auto bg-white/60 rounded-2xl p-5 border border-gray-200 flex items-start gap-3">
          <ShieldCheck className="text-teal shrink-0 mt-0.5" size={20} />
          <div>
            <h3 className="font-display text-lg text-teal-deep">{t.paywall.whyTitle}</h3>
            <p className="text-sm text-teal-soft mt-1 leading-relaxed">{t.paywall.whyText}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Paywall;
